export const common = {
  nav: {
    about: '회사소개',
    services: '서비스',
    partnership: '파트너십',
    network: '글로벌 네트워크',
    contact: '문의하기',
  },
  hero: {
    badge: '한국 ↔ 스리랑카 ↔ 서남아시아·중동',
    title1: '한국과 서남아시아·중동을 잇는',
    title2: '글로벌 유통 네트워크',
    subtitle: '스리랑카를 기점으로 서남아시아와 중동 지역에 한국 제품을 공급하고, 프리미엄 골든코코 브랜드로 전세계 시장을 개척합니다',
    cta1: '사업 제안하기',
    cta2: '골든코코 알아보기',
    stat1: {
      number: '530+',
      title: 'Cagil mart 점포',
      subtitle: '스리랑카 전역',
    },
    stat2: {
      number: '골든코코',
      title: '프리미엄 브랜드',
      subtitle: '전세계 수출',
    },
    stat3: {
      number: '무인점포',
      title: '스마트 리테일',
      subtitle: '국내 운영',
    },
  },
  services: {
    badge: 'Our Business',
    title: '핵심 사업 영역',
    subtitle: '한국과 스리랑카를 잇는 글로벌 유통 네트워크부터 프리미엄 브랜드 운영까지',
    items: [
      {
        title: '한국 제품 수출',
        description: '스리랑카를 기점으로 서남아시아와 중동 지역에 한국 공산품과 식품을 공급합니다. Cagil mart 530여개 점포와 현지 자회사 Global one을 통한 안정적인 유통망을 보유하고 있습니다.',
      },
      {
        title: '골든코코 브랜드',
        description: '스리랑카산 프리미엄 코코핏과 코코칩을 골든코코 브랜드로 전세계에 공급합니다. 친환경 원료로 글로벌 시장에서 인정받고 있습니다.',
      },
      {
        title: '무인점포 운영',
        description: '국내에서 스마트 무인점포를 운영하며 혁신적인 리테일 솔루션을 제공합니다. 24시간 운영으로 고객 편의성을 극대화합니다.',
      },
      {
        title: '현지법인 운영',
        description: '스리랑카 현지법인 Global one을 통해 서남아시아와 중동 시장 진출을 위한 안정적인 공급망을 구축하고 현지 시장에 대한 깊은 이해를 바탕으로 사업을 전개합니다.',
      },
      {
        title: '물류 네트워크',
        description: '한국에서 스리랑카를 거쳐 서남아시아와 중동 지역까지 연결하는 효율적인 물류 시스템으로 신속하고 안전한 제품 공급을 실현합니다.',
      },
      {
        title: '파트너십 구축',
        description: '서남아시아와 중동 지역의 글로벌 유통 파트너와의 긴밀한 협력을 통해 상호 성장하는 비즈니스 생태계를 만들어갑니다.',
      },
    ],
  },
  partnership: {
    badge: 'Partnership & Brand',
    title: '파트너십 & 브랜드',
    subtitle: '글로벌 유통 파트너와 자체 브랜드로 세계 시장을 선도합니다',
    items: [
      {
        name: 'Cagil mart',
        country: '스리랑카',
        description: '스리랑카 최대 유통망 Cagil mart 530여개 점포를 기점으로 서남아시아와 중동 지역에 한국 공산품과 식품을 공급하는 핵심 파트너십입니다. 현지법인 Global one을 통해 안정적인 유통망을 구축했습니다.',
      },
      {
        name: '골든코코 (Golden Coco)',
        country: '글로벌',
        description: '스리랑카산 프리미엄 코코핏과 코코칩을 전세계에 공급하는 자체 브랜드입니다. 친환경 원료로 유럽, 북미, 아시아 시장에서 높은 평가를 받고 있습니다.',
      },
      {
        name: 'Global one',
        country: '스리랑카',
        description: '스리랑카 현지 자회사로 서남아시아와 중동 지역 유통의 핵심 거점 역할을 담당합니다',
      },
      {
        name: '국내 무인점포',
        country: '대한민국',
        description: '스마트 기술을 활용한 무인점포를 국내에서 운영하며, 24시간 편의성과 효율적인 운영 시스템을 제공합니다.',
      },
      {
        name: '한국 제조사 파트너',
        country: '대한민국',
        description: '우수한 한국 공산품과 식품 제조사들과 파트너십을 맺고 스리랑카를 거쳐 서남아시아와 중동 시장 진출을 지원합니다.',
      },
      {
        name: '서남아시아·중동 바이어',
        country: '글로벌',
        description: '스리랑카를 거점으로 서남아시아와 중동 지역의 바이어들과 거래하며, 골든코코 브랜드를 통해 전세계 시장을 확대하고 있습니다.',
      },
    ],
  },
  cta: {
    title1: '한국과 서남아시아·중동을 잇는',
    title2: '글로벌 비즈니스 파트너',
    subtitle: '스리랑카 Cagil mart 530여개 점포 공급망을 기점으로 서남아시아와 중동 시장까지, INSIDE Global과 함께 성장하세요',
    button1: '사업 제안하기',
    button2: '골든코코 문의',
  },
  footer: {
    tagline: '한국 기업의 글로벌 파트너',
    about: {
      title: '회사소개',
      overview: '회사 개요',
      management: '경영진 소개',
      history: '연혁',
      careers: '채용 정보',
    },
    services: {
      title: '서비스',
      research: '시장 조사',
      matching: '파트너 매칭',
      legal: '법률 컨설팅',
      marketing: '마케팅 전략',
    },
    partnership: {
      title: '파트너십',
      cases: '성공 사례',
      network: '파트너 네트워크',
      inquiry: '제휴 문의',
      benefits: '파트너 혜택',
    },
    support: {
      title: '고객지원',
      faq: '자주 묻는 질문',
      contact: '문의하기',
      terms: '이용약관',
      privacy: '개인정보처리방침',
    },
    newsletter: {
      title: '글로벌 비즈니스의\n새로운 기준을\n만들어갑니다',
      subtitle: '최신 글로벌 비즈니스 소식을\n받아보세요',
      placeholder: '이메일 주소',
    },
    copyright: '© INSIDE Global 2025. All rights reserved.',
    poweredBy: 'for the world better place by inside global',
  },
};
